import { createStandardAction } from 'typesafe-actions';
import type { IExperiments } from './types';

const initExperiments =
  createStandardAction('EXPERIMENTS/INIT')<IExperiments>();

export { initExperiments };
